var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.629 12.957c.346.056.692.112 1.067.112h.517c3.579 0 5.812-2.426 7.181-4.251a1.128 1.128 0 0 0 0-1.357 12.035 12.035 0 0 0-1.662-1.784L11.25 8.222l.002.019c0 1.866-1.476 3.379-3.297 3.379l-.018-.003-1.308 1.339zm3.619-7.138l-1.17 1.199a1.613 1.613 0 0 0-1.124-.466c-.909 0-1.649.758-1.649 1.69 0 .447.178.849.456 1.151l-1.17 1.199a3.405 3.405 0 0 1-.935-2.35c0-1.866 1.476-3.379 3.297-3.379.893 0 1.701.367 2.294.957zm5.231-3.995c.184-.188.184-.494 0-.683s-.482-.188-.666 0l-3.056 3.132a7.743 7.743 0 0 0-3.543-.859h-.517c-2.804 0-5.219 1.324-7.181 3.938a1.098 1.098 0 0 0 0 1.372c.115.154.246.316.373.476v.007h.005c.81 1.019 1.874 2.121 3.229 2.891l-2.027 2.078a.492.492 0 0 0 0 .683.462.462 0 0 0 .667 0l2.269-2.325.011.004 1.323-1.355-.011-.005 1.282-1.313a.05.05 0 0 1 .012.002l1.895-1.942-.003-.013 1.281-1.313.005.011 1.789-1.834-.008-.007 2.874-2.946z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide_password.3f50de831f5aefc1431cdf281e99a21c.svg";
export { ForwardRef as ReactComponent };